module.exports = __webpack_public_path__ + "static/media/icon.7baa9f32.svg";


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/LegalButton/icon.svg
// module id = 509
// module chunks = 0